import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;

	img {
		position: absolute;
		top: 50%;
		right: 10px;
		transform: translateY(-50%);
		transition: filter 0.3s ease;
	}

	&:hover {
		img {
			filter: invert(100%);
		}
	}
`;

export { StyledContainer };
